import React from "react";
import { Box, Stack, Typography, useMediaQuery } from "@mui/material";
import { MacIcon } from "assets/icons";
import { desktop } from "utils";
import { CompanySearch } from "components";
import wave from "assets/images/wave.png";
import wave1 from "assets/images/wave1.png";

export const Hero = ({ recaptchaRef }) => {
  const matchesDesktop = useMediaQuery(desktop);

  return (
    <>
      <Stack alignItems="center" pt="2rem" backgroundColor={matchesDesktop ? "background2.main" : "primary.main"}>
        {matchesDesktop ? (
          <CompanySearch mobile recaptchaRef={recaptchaRef} />
        ) : (
          <MacIcon component={<CompanySearch recaptchaRef={recaptchaRef} />} />
        )}
      </Stack>
      <Box
        sx={{
          backgroundImage: `url(${matchesDesktop ? wave1 : wave})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "100%",
          paddingBottom: "25%",
        }}
      >
        {!matchesDesktop && (
          <Typography textAlign="center" variant="h1" fontSize="42px" color="background2.main">
            Pasitikrinkite savo verslo finansinę sveikatą!
          </Typography>
        )}
      </Box>
    </>
  );
};
